import { render, staticRenderFns } from "./Illness.vue?vue&type=template&id=453e037f&scoped=true"
import script from "./Illness.vue?vue&type=script&lang=js"
export * from "./Illness.vue?vue&type=script&lang=js"
import style0 from "./Illness.vue?vue&type=style&index=0&id=453e037f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e037f",
  null
  
)

export default component.exports